export enum LogoutAction {
	TIMEOUT = 'timeout',
	SECURITY = 'security',
	EXPIRED = 'expired',
	LOGOUT_TO_LOGIN_PAGE = 'logoutToLoginPage',
	LOGOUT_TO_START_PAGE = 'logoutToStartPage',
	NONE = 'none'
}
